module.exports = __webpack_public_path__ + "static/Derby2023-61b90634f96d5fc184bd876eb8fd176e.png";